// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"StartFundraisingLink_modalBody__IuplR","icon":"StartFundraisingLink_icon__vxtb_"};